module.exports = __webpack_public_path__ + "img/dapitana.5c2b0d9e.jpg";